import Axios from 'axios';
import { useState, useEffect } from 'react'
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { FormProvider, useForm } from 'react-hook-form';
import InputFile from '../InputsDinamicos/InputFile';
import { urlCertificadoCotizacion, urlBeforeSavePoliza } from 'src/services/urls'
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import { POST } from 'src/services';

const DescargaCertificados = (props: DescargaCertificadosProps) => {
    const { labelBtn = "", labelInput = "", codCore = "", submit } = props;
    const methods = useForm({ mode: 'onChange', shouldUnregister: false });
    const [loading, setloading] = useState(false)
    const [urlCe, setUrlCertificado] = useState('')
    const { idCotizacion, cotizacion } = useCotizacion()
    const { addErrorToast } = useCustomToast()
    const [textbtndescarga, settextbtndescarga] = useState('solicitud')
    const [txtLabel, setLabel] = useState('Subir solicitud firmada')

    const getCertificado = async () => {
        setloading(true)
        if (cotizacion?.producto?.firmaFisica === '1') {
            const data = await POST(urlBeforeSavePoliza(idCotizacion));
            if (data.transaccion) {
                setUrlCertificado(data.documento)
            }
            else {
                addErrorToast(data.mensaje || data?.errorDescripcion || 'No se pudo obtener el documento', { autoDismiss: true })
            }
            setloading(false);
        } else {
            Axios.post(urlCertificadoCotizacion(idCotizacion)).then(({ data }) => {
                if (data.transaccion) {
                    setUrlCertificado(data.documento)
                } else {
                    addErrorToast("Error consultando archivo")
                }
            }).catch(() => addErrorToast("Error al consultar archivo")).finally(() => setloading(false));
        }
    }
    useEffect(() => {
        getCertificado();
        settextbtndescarga(cotizacion?.producto?.firmaFisica === '1' ? 'certificado a firmar' : 'solicitud')
        setLabel(cotizacion?.producto?.firmaFisica === '1' ? 'Certificado a firmar' : labelInput || "Subir solicitud firmada")
    }, [])

    return (
        <Card style={{ width: '100%' }}>
            <div className="row justify-content-center py-3">
                <div className="container__form text-center">
                    <a href={urlCe} target="_blank" rel="noopener noreferrer" download>
                        <Button label={labelBtn || `${urlCe ? 'Descargar' : 'Obtener'} ${textbtndescarga}`} icon="pi pi-download" loading={loading} onClick={() => urlCe ? urlCe : getCertificado()} className="p-button-info" />
                    </a>
                </div>
            </div>
            <div className="row justify-content-center py-3">
                <FormProvider {...methods}>
                    <form
                        className=""
                        style={{ width: "100%" }}
                        noValidate
                        onSubmit={methods.handleSubmit((data) => submit(data))}
                    >
                        <div className="row" style={{ justifyContent: "space-around" }}>
                            <div className="col-9 col-sm-7">
                                <InputFile input={{
                                    callback: false,
                                    codCore: codCore || "certificadofirmado",
                                    default: "",
                                    disabled: false,
                                    editable: true,
                                    label: txtLabel,
                                    longitud: "",
                                    mandatorio: true,
                                    name: codCore || "certificadofirmado",
                                    orden: 1,
                                    required: false,
                                    rules: { required: "Este campo es obligatorio" },
                                    type: "archivo",
                                    unico: false,
                                    unique: "false",
                                    validacion: "archivo",
                                    value: ""
                                }} />
                            </div>
                            <div className="col-3 text-end d-flex justify-content-end align-items-end">
                                <Button label={"Guardar"} icon="pi pi-save" className={'p-button-success'} />
                            </div>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </Card>
    );
};
export default DescargaCertificados
export type DescargaCertificadosProps = {
    labelBtn?: string;
    labelInput?: string;
    codCore?: string;
    classNameContainer?: string;
    className?: string;
    submit: Function
};
